<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/environment-management/financial-year-quarters"
          ></back-button>
          Update Financial Year & Quarter
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/environment-management/financial-year-quarters`"
              >Financial Year & Quarters</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">Financial Year</label>
                  <div class="col-sm-10">
                    <input
                      v-if="this.form.from_year"
                      type="text"
                      v-model="form.financial_year"
                      class="form-control"
                      :placeholder="
                        'Jan - ' +
                        this.form.from_year +
                        ' - Dec - ' +
                        this.form.from_year
                      "
                      readonly
                    />
                    <input
                      v-else
                      type="text"
                      v-model="form.financial_year"
                      class="form-control"
                      placeholder="Financial Year"
                      readonly
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">To Month</label>
                  <div class="col-sm-10">
                    <input
                      v-if="this.form.from_year"
                      type="text"
                      v-model="form.to_month"
                      class="form-control"
                      placeholder="December"
                      readonly
                    />
                    <input
                      v-else
                      type="text"
                      v-model="form.to_month"
                      class="form-control"
                      placeholder="To Month"
                      readonly
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">To Year</label>
                  <div class="col-sm-10">
                    <input
                      v-if="this.form.from_year"
                      type="text"
                      v-model="form.to_year"
                      class="form-control"
                      :placeholder="this.form.from_year"
                      readonly
                    />
                    <input
                      v-else
                      type="text"
                      v-model="form.to_year"
                      class="form-control"
                      placeholder="To Year"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">From Month</label>
                  <div class="col-sm-10">
                    <input
                      v-if="this.form.from_year"
                      type="text"
                      v-model="form.from_month"
                      class="form-control"
                      placeholder="January"
                      readonly
                    />
                    <input
                      v-else
                      type="text"
                      v-model="form.from_month"
                      class="form-control"
                      placeholder="From Month"
                      readonly
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">From Year</label>
                  <div class="col-sm-10">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.from_year"
                      :suggestions="years"
                      placeholder="Select year"
                    ></my-select>
                  </div>
                </div>
                <div class="row mb-3">
                  <table>
                    <tr>
                      <th colspan="3" class="text-center">Quarter Setup</th>
                    </tr>
                    <tr>
                      <th>Quarter</th>
                      <th>Start</th>
                      <th>End</th>
                    </tr>
                    <tr>
                      <td>1st Quarter</td>
                      <td v-if="form.from_year">
                        Jan {{ this.form.from_year }}
                      </td>
                      <td v-if="form.from_year">
                        Mar {{ this.form.from_year }}
                      </td>
                    </tr>

                    <tr>
                      <td>2nd Quarter</td>
                      <td v-if="form.from_year">
                        Apr {{ this.form.from_year }}
                      </td>
                      <td v-if="form.from_year">
                        Jun {{ this.form.from_year }}
                      </td>
                    </tr>

                    <tr>
                      <td>3rd Quarter</td>
                      <td v-if="form.from_year">
                        Jul {{ this.form.from_year }}
                      </td>
                      <td v-if="form.from_year">
                        Sep {{ this.form.from_year }}
                      </td>
                    </tr>

                    <tr>
                      <td>4th Quarter</td>
                      <td v-if="form.from_year">
                        Oct {{ this.form.from_year }}
                      </td>
                      <td v-if="form.from_year">
                        Dec {{ this.form.from_year }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "Financial Year & QuarterUpdate",
  data() {
    return {
      form: {
        from_year: "",
      },
      years: [
        { id: 2022, name: 2022 },
        { id: 2023, name: 2023 },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/financial_year_quarters/${this.$route.params.financial_year_quarter_Id}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        this.form.financial_year =
          "Jan - " + this.form.from_year + " - Dec - " + this.form.from_year;
        this.form.to_month = "December";
        this.form.to_year = this.form.from_year;
        this.form.from_month = "January";
        await axios.patch(
          `/financial_year_quarters/${this.$route.params.financial_year_quarter_Id}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/environment-management/financial-year-quarters");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
